import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector:'ui-dropdown',
  styleUrls: ["./ui-styles.css"],
  template: ` <mat-form-field *ngIf="currentQuestion?.dataTypeName == 'dropdown'">
    <mat-select panelClass="custom-dropdown"
      [(value)]="currentQuestion.answerText"
      placeholder="Select option"
    >
      <mat-option
        *ngFor="let option of currentQuestion.options"
        [value]="option.value"
      >
        {{ option.text }}
      </mat-option>
    </mat-select>
  </mat-form-field>`
})

export class DropdownComponent implements OnInit {
    @Input() currentQuestion: any;

    constructor() { }

    ngOnInit() { }
}